export class LibrarySound {
  source: string;
  name: string;

  constructor(sound: LibrarySound = null) {
    if (sound == null) {
      this.source = "";
      this.name = "";
    } else {
      this.source = sound.source;
      this.name = sound.name;
    }
  }
}
